import React, {useState, useRef} from "react";
import useAuth from "../../auth/useAuth";
import ApiUser from "../../adapters/apiUser";
import ErrorList from "../common/MessageList";
import {Link} from 'react-router-dom';
import constants from "../../library/constants";
import commonFunctions from "../../library/commonFunctions";


export default function AccountForm(){
    const [errorMessages, setErrorMessage] = useState([]);
    const [completed, setCompleted] = useState(false);

    const handleDeleteAccountClick = async () => {
        const apiUser = new ApiUser();

        try{
            apiUser.userDeleteAccount(useAuth.getIdTokenAttribute("cognito:username"));
        }catch(err){
            setErrorMessage([JSON.stringify(err)]);
            console.error(JSON.stringify(err));
        }

        const updateContext = {
            'update_action' : 'delete-all'
        }

        commonFunctions.clearSessionStorage();
        setCompleted(true);

    }

   

    return(
    <>
    <div className="items-left-aligned">
    <ErrorList errors={errorMessages}/>

    {(completed) ?
    (
        <>
        <div>
        Your account has been deleted. 
        </div>        
        <hr/>
        <div>
        <Link to='/' className="button">Home</Link>
        </div>
        </>
    ):
    (
        <>
        <div className="mt-3">        
           
                <div className="text-left mt-4"><b>Username:</b> {useAuth.getIdTokenAttribute("email")}</div>   
                <div className="text-left text-sm mt-2">This is also your contact email.</div>                        
                <div className="mt-6">
                    <Link to="/resetpassword" className="btn btn-primary">Reset password</Link>
                </div>     
            <hr/>
            <div className="mt-12">
                <div className="text-left text-sm">If you wish to delete your account, click the Delete account button.</div>
                <button className="btn-secondary mt-2" onClick={handleDeleteAccountClick}>Delete account</button>
            </div>    
        </div>
        </>
    )
    }
    </div>
    </>
    );
}